import { FileDesc, Upload } from '@wellesley/openapi'
import isUploadReady, {
  isSafeFile,
  isSafeFileWithoutSize,
} from '../isUploadReady'
import isHLSVideo from 'helpers/is/isHLSVideo'

type HelperProps = {
  size: number
  upload?: Upload | null
  allowedExtensions?: string[]
  allowWithoutSize?: boolean
}

const isAllowedExtension = (file: FileDesc, allowedExtensions: string[]) => {
  const fileExtUpper = (file.extension || '').toUpperCase()
  return allowedExtensions.some((ext) => ext.toUpperCase() === fileExtUpper)
}

const selectUploadFile = ({
  size,
  upload,
  allowedExtensions,
  allowWithoutSize,
}: HelperProps) => {
  if (!upload || !isUploadReady(upload, allowWithoutSize)) return null

  const safeFiles = upload.files.filter(
    allowWithoutSize ? isSafeFileWithoutSize : isSafeFile,
  )

  const isVideo = upload.uploadType === 'VIDEO'

  if (isVideo) {
    const m3u8 = upload.files.find((f) => isHLSVideo(f.uri))

    if (m3u8) {
      return m3u8
    }
  }

  try {
    const isVertical = safeFiles[0].meta.height! > safeFiles[0].meta.width!
    const side = isVertical ? 'height' : 'width'

    let typedFiles = allowedExtensions?.length
      ? safeFiles.filter((file) => isAllowedExtension(file, allowedExtensions))
      : safeFiles

    if (!typedFiles.length) {
      typedFiles = safeFiles
    }

    if (isVideo) {
      const nonAvi = typedFiles.filter(
        (f) => (f.extension || '').toUpperCase() !== 'AVI',
      )
      if (nonAvi.length) typedFiles = nonAvi
    }

    const sortedBySize = typedFiles.sort(
      (f1, f2) => f1.meta[side]! - f2.meta[side]!,
    )

    const biggestFile = sortedBySize[sortedBySize.length - 1]
    const bestFitFile =
      sortedBySize.find((f) => f.meta[side]! >= size) || biggestFile

    return bestFitFile
  } catch {
    return safeFiles[0]
  }
}

export default selectUploadFile
